export default __webpack_public_path__ + "static/media/waving_gesture.c6fbf771.gif";